import { Injectable } from '@angular/core';
import { IFilter } from 'sol-request-angular/dist/comunicacao/interfaces/IFilter';
import { Orgao } from '@tivic-team/manager-ts/dist/mob';
import { Quark, HttpGet, Url, HttpResponse, HttpPost, JSONData, HttpPut } from 'sol-request-angular/dist/comunicacao';
import { environment } from 'src/environments/environment';
import { PagedResponse } from 'app/interfaces/paged-response.inteface';
import { LogradouroDTO } from 'app/model/dtos/grl/logradouro.dto';
import { environmentv3 } from 'src/environments/environmentv3';

@Injectable()
export class OrgaoController{
    
    constructor() { }
	
    async find(filtros?:IFilter):Promise<Array<Orgao>>{		
		let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/orgaos',
					environment: environment,
					filter: filtros
				}),
			}),
			new HttpResponse(
			  new Array<Orgao>()
			)
		);
		return await quark.call();
	}
	
	async create(orgao:Orgao):Promise<Orgao>{		
		let quark = new Quark(
			new HttpPost({
				url: new Url({
					id: 'mob/orgaos',
					environment: environment
				}),
				data: new JSONData(orgao)
			}),
			new HttpResponse(
			  new Array<Orgao>()
			)
		);
		return await quark.call();
	}
	
	async update(orgao:Orgao):Promise<Orgao>{		
		let quark = new Quark(
			new HttpPut({
				url: new Url({
					id: 'mob/orgaos/:cdOrgao',
					environment: environment,
					pathParams: new JSONData({cdOrgao: orgao.cdOrgao})
				}),
				data: new JSONData(orgao)
			}),
			new HttpResponse(
			  new Array<Orgao>()
			)
		);
		return await quark.call();
	}
	
	async get(cdOrgao:number):Promise<Orgao>{		
		let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/orgaos/:cdOrgao',
					environment: environment,
					pathParams: new JSONData({cdOrgao: cdOrgao})
				}),
			}),
			new HttpResponse(
			  new Orgao()
			)
		);
		return await quark.call();
	}
	
    findLogradouros(filtros?: IFilter): Promise<PagedResponse<LogradouroDTO>>{
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/orgaos/enderecos/logradouros',
                    environment: environmentv3,
                    filter: filtros
                }),
            }),
            new HttpResponse(
                new LogradouroDTO()
            )
        );
        return quark.call();
    }

}